import { useEffect, useRef } from "react";

export interface ContextMenuItem {
  label: string;
  icon?: React.ReactNode;
  onClick: () => void;
  danger?: boolean;
  divider?: boolean;
}

interface ContextMenuProps {
  x: number;
  y: number;
  items: ContextMenuItem[];
  onClose: () => void;
}

export function ContextMenu({ x, y, items, onClose }: ContextMenuProps) {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClick = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        onClose();
      }
    };
    const handleKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("mousedown", handleClick);
    document.addEventListener("keydown", handleKey);
    return () => {
      document.removeEventListener("mousedown", handleClick);
      document.removeEventListener("keydown", handleKey);
    };
  }, [onClose]);

  return (
    <div
      ref={ref}
      className="fixed z-50 min-w-44 rounded-lg border border-gray-700 bg-gray-900 py-1 shadow-2xl"
      style={{ left: x, top: y }}
    >
      {items.map((item, i) => (
        <div key={i}>
          {item.divider && <hr className="my-1 border-gray-700" />}
          <button
            className={`flex w-full items-center gap-2 px-3 py-2 text-sm transition-colors ${
              item.danger
                ? "text-red-400 hover:bg-red-900/30"
                : "text-gray-200 hover:bg-gray-800"
            }`}
            onClick={() => {
              item.onClick();
              onClose();
            }}
          >
            {item.icon && <span className="h-4 w-4">{item.icon}</span>}
            {item.label}
          </button>
        </div>
      ))}
    </div>
  );
}
